var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-3",
        attrs: { content: "Datos del Padre, Madre o Tutor", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              label: "Nombre Padre, Madre o Tutor:",
              value: _vm.model.tutor
            }
          }),
          _c("info-field", {
            staticClass: "col-4",
            attrs: { label: "Parentesco:", value: _vm.model.relationship }
          }),
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              "format-type": "phone",
              label: "Teléfono:",
              value: _vm.model.phoneNumber
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }